import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'
import Login from '../pages/Login.vue'

// IMPORT ROUTES FROM EXTERNAL FILES
import { unitaidRoutes } from '@/router/router-aegis.js';
import { srilankaRoutes } from '@/router/router-srilanka.js';
import { ugandaRoutes } from '@/router/router-uganda.js';
// add eavetubes
import { eavetubesRoutes } from '@/router/router-eavetubes.js';

import Register from '../pages/Register.vue'
import ForgotPassword from '../pages/ForgotPassword.vue'

import DashboardRoot from '../pages/dashboard/DashboardRoot.vue';
import ConsortiumReport from '../pages/dashboard/ConsortiumReport.vue';
// import Dashboard from '../pages/dashboard/Dashboard.vue';
import UserProfile from '../pages/user/UserProfile.vue';
import Users from '../pages/user/admin/Users.vue';
import EditUser from '../pages/user/admin/EditUser.vue';
import ChangePassword from '../pages/user/ChangePassword.vue';

import PageNotFound from '../pages/PageNotFound.vue';

import store from '../store/store';

import {
  HTTP
} from '@/utilities/http-common';

Vue.use(Router)

store.dispatch('initApp');
HTTP.defaults.headers.common['Authorization'] = store.getters.getAuthorizationHeader.Authorization;

store.dispatch('user/getUser').then(res => {
  store.dispatch('user/setUser', res.data);
}).catch(() => {});

store.dispatch('user/getMyGroups').then(res => {
  store.dispatch('user/setMyGroups', res.data);
}).catch(() => {});


let commonRoutes = [
  // {
  //   path: '',
  //   name: 'dashboard',
  //   component: Dashboard
  // },
  {
    path: 'user',
    name: 'user',
    component: UserProfile
  },
  {
    path: 'edit-user/:userId',
    name: 'edit-user',
    component: EditUser
  },
  {
    path: 'users',
    name: 'users',
    component: Users
  },
  {
    path: 'change-password',
    name: 'change-password',
    component: ChangePassword
  },
];

let childrenRoutes = commonRoutes

// add eavetubes
if ( process.env.VUE_APP_STUDY == 'srilanka') {
  childrenRoutes = childrenRoutes.concat(srilankaRoutes);
} else if ( process.env.VUE_APP_STUDY == 'uganda' ) {
  childrenRoutes = childrenRoutes.concat(ugandaRoutes);
} else if ( process.env.VUE_APP_STUDY == 'eavetubes' ) {
  childrenRoutes = childrenRoutes.concat(eavetubesRoutes);
} else {
  childrenRoutes = childrenRoutes.concat(unitaidRoutes);
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
      meta: { component: 'BaseTemplate' },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ '../pages/About.vue'),
      meta: { component: 'BaseTemplate' },
    },
    {
      path: '/login/',
      name: 'login',
      component: Login,
      meta: { component: 'BaseTemplate' },
    },
    {
      path: '/register/',
      name: 'register',
      component: Register,
      meta: { component: 'BaseTemplate' },
    },
    {
      path: '/forgot-password/',
      name: 'forgot-password',
      component: ForgotPassword,
      meta: { component: 'BaseTemplate' },
    },
    {
      path: '/consortium-report/',
      name: 'consortium-report',
      component: ConsortiumReport,
      meta: { requiresAuth: true, component: 'DashboardBaseTemplate' },
    },
    {
      path: '/dashboard/',
      component: DashboardRoot,
      meta: { requiresAuth: true, component: 'DashboardBaseTemplate' },
      children: childrenRoutes
    },
    {
      path: '*',
      name: 'not-found',
      component: PageNotFound,
      meta: { component: '*' }
    },

  ]
});

router.beforeEach((to, from, next) => {
  // set document title
  document.title = to.meta.title
    ? to.meta.title
    : process.env.VUE_APP_STUDY !== 'eavetubes'
      ? 'AEGIS'
      : 'Eave Tubes';
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(store.getters.isAuthenticated) {
      next();
    } else {
      next({
        name: 'login',
        query: {
          next: to.fullPath
        }
      });
    }

  } else {
    next();
  }
});

router.afterEach(() => {
  window.scroll({top: 0, left: 0, behavior: 'smooth'});
});

export default router;